// @flow
import React from "react";
import classNames from "classnames";
type $Props = {
  query: string,
  address: string,
  photo: string,
  classes: Object,
};

const ListingCardPhoto = (props: $Props) => {
  const { classes, address, photo, query } = props;
  return (
    <img
      className={classNames(classes.img, "ref__primaryPhoto")}
      srcSet={`
            ${photo}&auto=format&fit=crop&w=280&h=160&or=0&dpr=1${query} 1x,
            ${photo}&auto=format&fit=crop&w=280&h=160&or=0&dpr=2${query} 2x,
            ${photo}&auto=format&fit=crop&w=280&h=160&or=0&dpr=3${query} 3x,
          `}
      sizes="280px"
      src={`${photo}&fit=crop&w=280&h=160&or=0${query}`}
      alt={address}
    />
  );
};
export default ListingCardPhoto;
